export default "__VITE_ASSET__jjuwwsPb__"